import { useEffect, useState } from 'react';
import { hasAffiliateBeenChecked } from '../lib/hasAffiliateBeenChecked';

/**
 * This hook is used to check if the affiliate has been checked.
 * @returns {boolean}
 */
const useAffiliateCheckedHook = (): boolean => {
    const [hasBeenChecked, setHasBeenCheked] = useState(hasAffiliateBeenChecked());

    useEffect(() => {
        const onCheckEvent = () => setHasBeenCheked(true);

        /** Event fired in manageAffiliateCode.js */
        window.addEventListener('affiliate_checked', onCheckEvent, false);
        return () => {
            window.removeEventListener('affiliate_checked', onCheckEvent);
        };
    }, []);

    return hasBeenChecked;
};

export default useAffiliateCheckedHook;
